var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-image", {
    staticClass: "brand-image",
    attrs: { src: _vm.url, fit: "contain" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }